import $ from 'jquery';
import { goToPage } from '~src/multipages';
import { getState } from '~src/state';

export const handleChangePageBtn = (event) => {
  event.preventDefault();
  const pageIndex = $(event.currentTarget).data('page-index');
  const currentPageIndex = getState('currentPageIndex');

  if (event.target.id.startsWith('btn-page-delete-')) {
    return;
  }

  // Don't reload if clicking on the current page
  if (pageIndex === currentPageIndex) {
    return;
  }

  return goToPage(pageIndex);
};
